import React from 'react'
import ResearchAssistantCardComponent from '@fs/zion-ade-abbie'
import ErrorBoundary from '@fs/zion-error-boundary'
import { type Person } from '@fs/zion-tree-types'

export default function ResearchAssistantCard({ focusPerson }: { focusPerson: Person }): JSX.Element {
  return (
    <ErrorBoundary>
      <ResearchAssistantCardComponent focusPerson={focusPerson} />
    </ErrorBoundary>
  )
}
